import { render, staticRenderFns } from "./IconPDF.vue?vue&type=template&id=1ff591d6&scoped=true&"
import script from "./IconPDF.vue?vue&type=script&lang=js&"
export * from "./IconPDF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff591d6",
  null
  
)

export default component.exports